import { EnvelopeSimple, Phone } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-xl font-medium mb-4" data-testid="footer-brand">N K BORKAR & CO.</h3>
            <p className="text-slate-400 text-sm" data-testid="footer-tagline">
              Professional accounting and consulting services for businesses of all sizes.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-slate-400" data-testid="footer-quicklinks-title">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-300 hover:text-white text-sm" data-testid="footer-link-home">Home</Link></li>
              <li><a href="/#about" className="text-slate-300 hover:text-white text-sm" data-testid="footer-link-about">About Us</a></li>
              <li><a href="/#services" className="text-slate-300 hover:text-white text-sm" data-testid="footer-link-services">Services</a></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white text-sm" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-slate-400" data-testid="footer-contact-title">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <EnvelopeSimple size={20} className="text-slate-400" />
                <a href="mailto:ca.nileshborkar@gmail.com" className="text-slate-300 hover:text-white text-sm" data-testid="footer-email">
                  ca.nileshborkar@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={20} className="text-slate-400" />
                <a href="tel:+919773729261" className="text-slate-300 hover:text-white text-sm" data-testid="footer-phone">
                  +91 9773729261
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center">
          <p className="text-slate-400 text-sm" data-testid="footer-copyright">
            © {new Date().getFullYear()} N K Borkar & Co. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};